var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8256 5.76052C17.232 6.29198 17.232 7.00946 16.8256 7.54006C15.5459 9.21074 12.4754 12.6507 8.89056 12.6507C5.30576 12.6507 2.23527 9.21074 0.955476 7.54006C0.757512 7.28571 0.650024 6.9726 0.650024 6.65029C0.650024 6.32798 0.757512 6.01487 0.955476 5.76052C2.23527 4.08984 5.30576 0.649902 8.89056 0.649902C12.4754 0.649902 15.5459 4.08984 16.8256 5.76052Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8905 9.22229C10.3108 9.22229 11.4621 8.07095 11.4621 6.6507C11.4621 5.23044 10.3108 4.0791 8.8905 4.0791C7.47025 4.0791 6.31891 5.23044 6.31891 6.6507C6.31891 8.07095 7.47025 9.22229 8.8905 9.22229Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3a9dcccb2f6eedb25102f4eeaa998980.svg";
export { ForwardRef as ReactComponent };